import React, { useEffect, useState } from "react";
import { Row, Col, Button, Radio, Table, DatePicker } from "antd";
import Chart from "./chart";
import SystemApi from "../../../../api/sys";
import RenderTxt from "../../../../components/renderTxt";
const { RangePicker } = DatePicker;

export default ({ deviceId }) => {
  const [searchParams, setSearchParams] = useState({
    attrCode: "",
  });
  const [dataSource, setDataSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [time, setTime] = useState([]);
  const [dataType, setDataType] = useState(1);
  const [chartData, setChartData] = useState({});
  const [seriesList, setSeriesList] = useState([]);
  const [xAxis, setXAxis] = useState([]);
  const [columns, setColumns] = useState([
    {
      width: 140,
      title: "参数名",
      dataIndex: "attrName",
      align: "center",
      key: "attrName",
      ellipsis: {
        showTitle: false,
      },
      render: (text) => RenderTxt(text),
    },
  ]);

  useEffect(() => {
    if (deviceId) {
      getList();
      if (dataType == 2) {
        getChartData(xAxis, seriesList);
      }
    }
  }, [deviceId, searchParams, dataType]);

  const getList = () => {
    const params = {
      gatherDevId: deviceId,
      ...searchParams,
    };
    setLoading(true);
    SystemApi.pointIndicatorListHistory(params).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const values = [];
      const dataListLen = [];
      const cArr = [];
      res.data.forEach((item, index) => {
        cArr.push({
          name: item.attrName,
          type: "line",
          data: item.dataList.map((s) => s.value * 1),
          label: {
            show: true,
            position: "top",
            formatter: "{c}", // 显示具体数值
          },
        });
        const arr = {
          attrName: item.attrName,
          key: index + 1,
        };
        item.dataList.forEach((subItem) => {
          let key = subItem.collectTime.replaceAll("-", "");
          key = key.replaceAll(" ", "");
          key = key.replaceAll(".", "");
          key = key.replaceAll(":", "");
          arr["t" + key] = subItem.value;
        });
        dataListLen.push(item.dataList.length);
        values.push(arr);
      });
      const maxNum = Math.max(...dataListLen);
      const maxIndex = dataListLen.indexOf(maxNum);
      const x = [];
      const header = res.data[maxIndex].dataList.map((item) => {
        let key = item.collectTime.replaceAll("-", "");
        key = key.replaceAll(" ", "");
        key = key.replaceAll(".", "");
        key = key.replaceAll(":", "");
        x.push(item.collectTime);
        return {
          title: item.collectTime,
          dataIndex: "t" + key,
          key: "t" + key,
          width: 140,
          align: "center",
          ellipsis: {
            showTitle: false,
          },
          render: (text) => RenderTxt(text),
        };
      });
      setXAxis(x);
      columns.push(...header);
      setColumns(() => {
        return [...columns];
      });
      setDataSource(values);
      if (dataType == 2) {
        getChartData(x, cArr);
      }
      setSeriesList(cArr);
    });
  };

  const getChartData = (x, series) => {
    const option = {
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: series.map((item) => item.name),
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: x,
      },
      yAxis: {
        type: "value",
      },
      series,
    };
    setChartData(() => {
      return { ...option };
    });
  };

  const changeType = (e) => {
    const value = e.target.value;
    setDataType(value);
  };

  const reset = () => {
    setSearchParams({
      attrCode: "",
    });
    setTime([]);
  };

  const search = () => {
    setSearchParams({
      ...searchParams,
      startTime: time[0]
        ? time[0].format("YYYY-MM-DD") + " 00:00:00"
        : undefined,
      endTime: time[1] ? time[1].format("YYYY-MM-DD") + " 23:59:59" : undefined,
    });
  };

  return (
    <div style={{ marginTop: 20 }}>
      <Row>
        <Col span={8}>
          <Row style={{ alignItems: "center" }}>
            <Col span={4}>时间</Col>
            <Col span={20}>
              <RangePicker value={time} onChange={(e) => setTime(e)} />
            </Col>
          </Row>
        </Col>
        <Col span={6}>
          <Button onClick={reset}>重置</Button>
          <Button type="primary" style={{ marginLeft: 8 }} onClick={search}>
            查询
          </Button>
        </Col>
        <Col span={8}>
          <Radio.Group
            style={{ width: "100%" }}
            value={dataType}
            onChange={changeType}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button value={1}>表格</Radio.Button>
            <Radio.Button value={2}>图表</Radio.Button>
          </Radio.Group>
        </Col>
      </Row>
      {dataType == 1 ? (
        <Table
          scroll={{ x: columns.reduce((a, b) => a + b.width, 0) }}
          columns={columns}
          dataSource={dataSource}
          loading={loading}
          pagination={false}
        />
      ) : (
        <div className="chart-box" style={{ width: "100%", height: 500 }}>
          <Chart height={500} id="hisChart" chartData={chartData} />
        </div>
      )}
    </div>
  );
};
